
<div [ngStyle]="{ 'display' : coodinatePointsFilterController.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <form autocomplete="off"
id="ngForm1"
[ngClass]="[this.coodinatePointsFilterController.active ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']"
name="ngForm1"
#ngForm1="ngForm"
id="coordinatePointsPrimaryForm"
style="height: 600px">
  <div class="fields__block">
    <div class="fields__block__section">
      <div class="title">
        <h4>Fields Options</h4>
        <span> </span>
      </div>
      <div class="dropdown-fields">

        <div>
          <label for="">Fields</label>
          <select  name="filter_typeCoordinatePoints" id="filter_typeCoordinatePoints" (change)="typeChanged($event.target.value)">
            <option value="type">Type</option>
            <option value="published">Published</option>
          </select>
        </div>

        <div *ngIf="this.values.length > 0">
          <label for=""></label>
          <select  id="valuesCoordinatePoints" name="valuesCoordinatePoints" [disabled]="dropdown_values_enabled ? false : true">
              <option *ngFor="let item of this.values" [value]="item">{{item}}</option>
          </select>
        </div>

        <div class="input-fields" *ngIf="showPublishedSlider">
          <label style="width: 25%;" for=""></label>
          <div style="justify-content: flex-start;width: 50%;">
            <input type="checkbox" id="filter_publishedCoordinatePoints" name="filter_publishedCoordinatePoints" [(ngModel)]="isPublishedSliderChecked" [value]="true" [disabled]="!showPublishedSlider">
            <label for="filter_publishedCoordinatePoints" style="width: calc(100% - 20px);">{{ updatePublishedLabel() }}</label>
          </div>
        </div>

      </div>

      <div class="input-fields">
        <div class="btn">
          <button type="submit" (click)="addFilter()">Add Filter</button>
        </div>

      </div>

    </div>
  </div>

  <div class="fields__block">
    <div class="fields__block__section">
      <div class="title">
        <h4>Applied Filters</h4>
        <span> </span>
      </div>

      <div class="table-fields">
        <div>
          <div class="scrollable">
            <table >
              <thead>
                <tr>
                  <th>Field</th>
                  <th scope="col">Value</th>
                  <th scope="col">Active</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let filter of this.coodinatePointsFilterController.filters; let i = index" [class.highlighted]="filter.isSelected" (click)="selectFilter(filter)">
                  <td>{{ filter.field }}</td>
                  <td>{{ filter.value }}</td>
                  <td>{{ filter.active }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="btn">
            <button type="submit" (click)="applyFilter()">Apply Filter</button>
            <button type="submit" (click)="deleteSelectedFilterFromList()">Remove Filter</button>
            <button type="submit" (click)="resetFilters()">Reset</button>
          </div>
        </div>
      </div>

      <div class="notes">{{pointsService.informationMessageCoordinatePoints}}</div>


    </div>
  </div>
</form>
</div>


